// Lib
import React from 'react';

// Components
import DebugUIPoint from '../../../debug/ui/DebugUIPoint';
import DebugUILineVector from '../../../debug/ui/DebugUILineVector';

// Utils
import * as pointLib from '../../../../common/maths/geometry/point';
import dragAndDropStateSingleton from '../../../element/dnd/dragAndDropStateSingleton';
import { ImMap, prop } from '../../../../common/utils/immutableHelper';

// Types
import { Point } from '../../../../common/maths/geometry/pointTypes';
import { DNDDebugToolProperties } from '../../../debug/dragAndDrop/DragAndDropDebugToolTypes';

interface Props {
    item: any;
    clientOffset: Point;
    sourceClientOffset: Point;
    dndDebugToolProperties: ImMap<DNDDebugToolProperties>;
}

const ElementDragLayerDebugUI = (props: Props) => {
    const { item, clientOffset, sourceClientOffset, dndDebugToolProperties } = props;

    const debugShowClientOffset = prop('showClientOffset', dndDebugToolProperties);
    const debugShowSourceClientOffset = prop('showSourceClientOffset', dndDebugToolProperties);
    const debugShowCustomDragOffset = prop('showCustomDragOffset', dndDebugToolProperties);
    const debugShowGrabOffset = prop('showGrabOffset', dndDebugToolProperties);

    return (
        <div className="ElementDragLayerDebugUI">
            {debugShowClientOffset && (
                <DebugUIPoint color="var(--debug-ui-point-client-offset-color)" offset={clientOffset} />
            )}
            {debugShowSourceClientOffset && (
                <DebugUIPoint color="var(--debug-ui-point-source-client-offset-color)" offset={sourceClientOffset} />
            )}
            {debugShowCustomDragOffset && item.scaledCustomDragOffset && (
                <DebugUILineVector
                    color="var(--debug-ui-line-custom-drag-offset-color)"
                    offset={sourceClientOffset}
                    vector={pointLib.scale(-1, item.scaledCustomDragOffset)}
                />
            )}
            {debugShowGrabOffset && dragAndDropStateSingleton.scaledGrabOffset && (
                <DebugUILineVector
                    color="var(--debug-ui-line-grab-offset-color)"
                    offset={clientOffset}
                    vector={dragAndDropStateSingleton.scaledGrabOffset}
                />
            )}
        </div>
    );
};

export default ElementDragLayerDebugUI;
